module.exports = __webpack_public_path__ + "static/media/users-green.85bc8584.png";